import { GetterTree } from 'vuex';
import { ProfileState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<ProfileState, RootState> = {

    /**
     * Check if customer module is enabled.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    anagraficaModuleEnabled: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('customers') || rootGetters.permissionEnabled('leads') || rootGetters.permissionEnabled('suppliers');
    },
    
    /**
     * Check if user can view all company's users.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canViewCompanyUsers: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('companies.viewCompanyUsers');
    },

    //check customer permissions

    /**
     * Check if user can create customer.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canCreateCustomer: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('customers.create');
    },

    /**
     * Check if user can view all customer.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canViewAnyCustomer: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('customers.viewAny');
    },

    /**
     * Check if user can view customer.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canViewCustomer: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('customers.view');
    },

    /**
     * Check if user can update customer.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canUpdateCustomer: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('customers.update');
    },

    /**
     * Check if user can delete customer.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canDeleteCustomer: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('customers.delete');
    },

    //check supplier permissions

    /**
     * Check if user can create supplier.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canCreateSupplier: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('suppliers.create');
    },

    /**
     * Check if user can view all supplier.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canViewAnySupplier: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('suppliers.viewAny');
    },

    /**
     * Check if user can view supplier.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canViewSupplier: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('suppliers.view');
    },

    /**
     * Check if user can update supplier.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canUpdateSupplier: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('suppliers.update');
    },

    /**
     * Check if user can delete supplier.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canDeleteSupplier: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('suppliers.delete');
    },

    //check lead permissions

    /**
     * Check if user can create lead.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canCreateLead: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('leads.create');
    },

    /**
     * Check if user can view all lead.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canViewAnyLead: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('leads.viewAny');
    },

    /**
     * Check if user can view lead.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canViewLead: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('leads.view');
    },

    /**
     * Check if user can update lead.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canUpdateLead: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('leas.update');
    },

    /**
     * Check if user can delete lead.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canDeleteLead: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('leads.delete');
    },

    /**
     * Get the active profile.
     *
     * @param state
     * @param myGetters
     */
    activeProfile: (state, myGetters) => {
        return myGetters.getProfileById(state.activeProfileId);
    },

    /**
     * Return the specified profile.
     *
     * @param state
     */
    getProfileById: (state) => (id: number) => {
        return state.profiles.find((profile) => profile.id === id);
    },

    /**
     * Check if profile is in collection.
     *
     * @param state
     * @param myGetters
     */
    isProfileLoaded: (state, myGetters) => (id: number): boolean => {
        return !!myGetters.getProfileById(id);
    },


    /**
     * Get the active profile.
     *
     * @param state
     * @param myGetters
     */
    activeBrand: (state, myGetters) => {
        return myGetters.getBrandById(state.activeBrandId);
    },

    /**
     * Return the specified profile.
     *
     * @param state
     */
    getBrandById: (state) => (id: number) => {
        return state.brands.find((brand) => brand.id === id);
    },

    /**
     * Check if price list is in collection.
     *
     * @param state
     * @param myGetters
     */
    isBrandLoaded: (state, myGetters) => (id: number): boolean => {
        return !!myGetters.getBrandById(id);
    },

    /**
     * Return the specified company.
     *
     * @param state
     */
    getCompanyById: (state) => (id: number) => {
        return state.companies.find((company) => company.id === id);
    },

};
